/**
 * 历史路径 /questionnaires/:id/report/view
 *
 * "查看大报告"入口已统一收敛到统计页（/statistics?tab=report），
 * 这个页面只做向后兼容的 redirect。
 */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const ReportViewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <Navigate to={`/questionnaires/${id}/statistics?tab=report`} replace />;
};

export default ReportViewPage;
